import { useState, useCallback } from 'react';
import { useRejectCommercialOfferMutation } from 'api';

export const useRejectOffer = (
  rejectForm: any,
  handleSuccess: (message: string) => void,
  handleError: (error: any) => void
) => {
  const [offerToReject, setOfferToReject] = useState<string | undefined>();
  const [rejectOffer, { isLoading: isLoadingReject }] = useRejectCommercialOfferMutation();

  const closeModal = useCallback(() => {
    setOfferToReject(undefined);
    rejectForm.resetFields();
  }, [rejectForm]);

  const handleReject = useCallback(async () => {
    try {
      const values = await rejectForm.validateFields();

      const result = await rejectOffer({
        data: {
          id: offerToReject,
          rejectionReason: values.rejectionReason,
          additionalInformation: values.additionalInformation,
        },
        commercialOfferId: offerToReject,
      });

      if ('error' in result) {
        handleError('Failed to reject deal');
        return;
      }

      handleSuccess('Commercial Offer was successfully rejected.');
      closeModal();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  }, [rejectForm, rejectOffer, offerToReject, closeModal, handleSuccess, handleError]);

  return {
    offerToReject,
    setOfferToReject,
    isLoadingReject,
    handleReject,
    closeModal,
  };
};
